import * as angular from "angular";

export function openUrl(url: string) {

    var downloadLink = angular.element("<a></a>");
    downloadLink.attr("href", url);

    var event = new MouseEvent("click");
    downloadLink[0].dispatchEvent(event);

}

export function downloadDataAsFile(data: any, fileName: string, contentType: string) {

    const blob = new Blob([data], { type: contentType });

    const downloadLink = angular.element("<a></a>");
    downloadLink.attr("href", window.URL.createObjectURL(blob));
    downloadLink.attr("download", fileName);

    const event = new MouseEvent("click");
    downloadLink[0].dispatchEvent(event);

}
